import { ComponentPropsWithoutRef, forwardRef } from "react";
import { SortDirection } from "../Table.Parts";
import { Icon } from "./SortIcon.Parts";

export const SortIcon = forwardRef<
  SVGSVGElement,
  ComponentPropsWithoutRef<"svg"> & {
    $sortDirection: SortDirection;
  }
>((props, ref) => (
  <Icon
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <>
      <path d="M11.725 18.88L5.75501 12.91C5.59501 12.75 5.59501 12.5 5.75501 12.34L6.81501 11.28C6.97501 11.12 7.22501 11.12 7.38501 11.28L11.715 15.61C11.875 15.77 12.125 15.77 12.285 15.61L16.615 11.28C16.775 11.12 17.025 11.12 17.185 11.28L18.245 12.34C18.405 12.5 18.405 12.75 18.245 12.91L12.275 18.88C12.115 19.04 11.865 19.04 11.705 18.88L11.725 18.88Z" />
      <path d="M10.8401 5.3482L10.8401 16.6518C10.8401 16.8441 11.0237 17 11.2501 17L12.7401 17C12.9665 17 13.1501 16.8441 13.1501 16.6518L13.1501 5.34819C13.1501 5.15589 12.9665 5 12.7401 5L11.2501 5C11.0237 5 10.8401 5.15589 10.8401 5.3482Z" />
    </>
  </Icon>
));
